/**
 * State used in rendering CardFooter.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
